import type { BankApp, BankPlatform } from '../data/bankApps';
import UAParser from 'ua-parser-js';

interface BankNavigator {
    userAgent: string;
    platform?: string;
    maxTouchPoints?: number;
}

export const detectBankPlatform = (navigatorInfo?: BankNavigator): BankPlatform => {
    if (!navigatorInfo) return 'unknown';
    const { userAgent, platform = '', maxTouchPoints = 0 } = navigatorInfo;
    // Some unsupported mobile browsers include Android or desktop tokens in their UA.
    if (/Windows Phone|IEMobile|BlackBerry|BB10|Silk|Kindle|webOS|Opera Mini/i.test(userAgent)) return 'unknown';
    if (/Android/i.test(userAgent)) return 'android';
    if (/iPhone|iPad|iPod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1)) return 'ios';
    if (/Mobile|Tablet/i.test(userAgent)) return 'unknown';
    if (/Windows NT|Macintosh|X11|Linux|CrOS/i.test(userAgent) || /^(Win32|Win64|MacIntel|Linux)/i.test(platform)) return 'desktop';
    return 'unknown';
};

export const isAndroidWebView = (navigatorInfo?: BankNavigator): boolean =>
    detectBankPlatform(navigatorInfo) === 'android'
    && /(?:^|[\s;(])wv(?=$|[\s;)])/i.test(navigatorInfo?.userAgent || '');

// Match the browser category used by OpenPanel, not the WebKit engine shared by Safari.
export const isIosWebKit = (navigatorInfo?: BankNavigator): boolean =>
    detectBankPlatform(navigatorInfo) === 'ios'
    && new UAParser(navigatorInfo?.userAgent).getBrowser().name === 'WebKit';

export const getBankTarget = (bank: BankApp, platform: BankPlatform): string | null => {
    if (platform === 'android' || platform === 'ios') return bank[platform].url;
    // A desktop QR can be scanned by either OS, so require a shared link.
    if (platform === 'desktop' && bank.android.url === bank.ios.url) return bank.android.url;
    return null;
};
